import React, { useState } from "react";
import "./ECLImageUploader.css";
import { translate } from "../../../utilities/Translate";
import { ECLFileInput, ECLThemeImage } from "../../index";
import useSelectorId from "../../../utilities/hooks/useSelectorId";
import ECLDialog from "../../Widgets/ECLDialog/ECLDialog";

/**
 * Props
 * name - label for the image uploader field
 * id - string optional - used to set the input's id
 * required - optional - used to set whether the field is required or not
 **/

const ECLImageUploader = (props) => {
   const [selectedImage, setSelectedImage] = useState();
   const inputId = useSelectorId();
   const imageChange = (e) => {
      if (e.target.files && e.target.files.length > 0) {
         setSelectedImage(e.target.files[0]);
      }
   };

   const removeSelectedImage = () => {
      setSelectedImage("");
      const input = document.getElementById(inputId);
      input.value = "";
   };

   return (
      <>
         <div className="container">
            <label
               style={{ display: props.name ? "block" : "none" }}
               data-testid={props.id}
               htmlFor={props.id}
            >
               {props.name}
               {props.required && <span className="required-input"> *</span>}
            </label>
            {selectedImage && (
               <div className="preview">
                  <ECLDialog
                     title={translate("Image Viewer")}
                     triggerText={
                        <img
                           src={URL.createObjectURL(selectedImage)}
                           className="image-preview"
                        />
                     }
                     triggerClass={"image-preview-thumbnail"}
                     customButtons={{}}
                     inlineStyle={{
                        width: "100%",
                        height: "100%",
                        padding: "0px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                     }}
                  >
                     <img
                        src={URL.createObjectURL(selectedImage)}
                        alt="Thumb"
                        className="image"
                     />
                  </ECLDialog>
                  <div className={"delete"}>
                     <button onClick={removeSelectedImage}>
                        <ECLThemeImage
                           fontAwesome="xmark"
                           alt={translate("Remove Image")}
                        />
                     </button>
                  </div>
               </div>
            )}
            <ECLFileInput
               id={props.id ? props.id : "image-picker" + inputId}
               mimetypes="image/*"
               onChange={imageChange}
            />
         </div>
      </>
   );
};

export default ECLImageUploader;
